<template>
  <!-- <div>
    <date-picker
      @changeTime="changeTime"
      :defaultTime="[startTime, endTime]"
    ></date-picker>
  </div> -->
  <el-row class="userheder">
    <el-col>
      <el-form :inline="true" :model="formSearch" ref="formSearch" class="demo-form-inline">
        <el-col class="date">
          <el-form-item label="日期">
            <date-picker @changeTime="changeTime" :defaultTime="[startTime, endTime]"></date-picker>
          </el-form-item>

          <el-form-item label="应用">
            <el-select v-model="formSearch.appId" filterable placeholder="全部">
              <el-option
                v-for="item in productList"
                :key="item.adsAppId"
                :label="`${item.appName} (${item.afid})`"
                :value="item.adsAppId"
              ></el-option>
              <!-- <el-option label="小米" :value="2"></el-option>
              <el-option label="oppo" :value="3"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="商店">
            <el-select v-model="formSearch.shop" filterable placeholder="全部">
              <el-option label="华为" :value="1"></el-option>
              <!-- <el-option label="vivo" :value="2"></el-option>
              <el-option label="oppo" :value="3"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="广告类型">
            <el-select v-model="formSearch.adzType" filterable placeholder="全部">
              <el-option label="华为-pps" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区">
            <areaMultiSelect :value.sync="formSearch.geo" :optionsList="countryList"> </areaMultiSelect>
          </el-form-item>
          <el-form-item label="显示方式">
            <el-select v-model="formSearch.showType" filterable placeholder="全部">
              <el-option label="分日" :value="1"></el-option>
              <el-option label="分周" :value="2"></el-option>
              <el-option label="分月" :value="3"></el-option>
              <!-- <el-option label="合计" :value="4"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <select-property
              :itemList="column"
              :num="6"
              @getColumn="getColumn"
              :defaultColumn="defaultColumn"
              :defaultCheckAll="true"
            ></select-property>
          </el-form-item>
          <el-form-item>
            <el-button @click="downloadData">下载数据</el-button>
          </el-form-item>
        </el-col>
        <el-col> </el-col>
      </el-form>
    </el-col>
    <!-- <el-col :span="4" class="headerleft">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <i class="el-icon-refresh" @click="onSubmit('formSearch')" />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="下载excel"
        placement="top"
      >
        <i class="el-icon-download" @click="downloadFile" />
      </el-tooltip>
    </el-col> -->
  </el-row>
</template>
<script>
import DatePicker from "./datePicker.vue";
import selectProperty from "./selectProperty";
import { huaweiRportColumn } from "../../config/table_comlun";
import moment from "moment";
import { getCountryListFetch, getAppListFetch } from "../../api/api";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
export default {
  data() {
    return {
      defaultColumn: ["installRate", "cost", "downloadCost", "activeCost", "dau", "income", "incRoi", "arpu"],
      column: Object.freeze(huaweiRportColumn),
      tableColumn: huaweiRportColumn,
      startTime: moment(new Date()),
      endTime: moment(new Date()),
      formSearch: {
        dateStart: moment(new Date()).format("YYYYMMDD"),
        dateEnd: moment(new Date()).format("YYYYMMDD"),
        appId: 11585, // 应用
        shop: 1, //商店
        adzType: 1, //广告类型
        geo: [], //地区
        showType: 1, //显示方式
      },
      selectColumns: [],
      countryList: [],
      productList: [],
    };
  },
  components: { DatePicker, selectProperty, areaMultiSelect },
  mounted() {
    this.getCountryData();
    this.getAppListData();
  },
  methods: {
    getAppListData() {
      getAppListFetch().then((res) => {
        console.log(res, "res");
        const { productList, code } = res;
        if (code == "0000") {
          this.productList = productList;
          this.formSearch.appId = productList[0].adsAppId;
        }
      });
    },
    getCountryData() {
      getCountryListFetch({ afid: null }).then((result) => {
        console.log(result);

        const { countryList, code } = result;
        if (code == "0000") {
          this.countryList = countryList;
        }
      });
    },
    changeTime(time) {
      console.log(time, "time");
      this.formSearch.dateStart = time[0] ? moment(time[0]).format("YYYYMMDD") : "";
      this.formSearch.dateEnd = time[1] ? moment(time[1]).format("YYYYMMDD") : "";
    },
    getColumn(arr) {
      this.tableColumn = arr;
      console.log(arr);
      this.$emit("tableColumn", arr);
    },
    downloadData() {
      const data = JSON.parse(JSON.stringify(this.formSearch));
      data.geo = data.geo.join(",");
      this.$emit("downloadData", data);
    },
    onSubmit() {
      const data = JSON.parse(JSON.stringify(this.formSearch));
      data.geo = data.geo.join(",");
      this.$emit("getPopuInfo", data);
    },
  },
};
</script>
